import { CdkPortal, DomPortalOutlet, PortalOutlet } from '@angular/cdk/portal';
import { AfterViewInit, ApplicationRef, Component, Injector, OnDestroy, ViewChild } from '@angular/core';

@Component({
  standalone: false,
  selector: 'campus-shell-body-header',
  template: '<ng-template cdkPortal><ng-content></ng-content></ng-template>',
})
export class ShellBodyHeaderComponent implements AfterViewInit, OnDestroy {
  private portalHost: PortalOutlet;
  @ViewChild(CdkPortal) portal;

  constructor(
    private injector: Injector,
    private appRef: ApplicationRef
  ) {}

  ngAfterViewInit(): void {
    // Create a portalHost from a DOM element
    this.portalHost = this.getPortalHost('#ui-shell__body-header');
    // Attach portal to host
    if (this.portalHost != null) {
      this.portalHost.attach(this.portal);
    }
  }

  ngOnDestroy(): void {
    if (this.portalHost != null) {
      this.portalHost.detach();
    }
  }

  private getPortalHost(selector: string) {
    const element = document.querySelector(selector);
    if (element === null) return null;
    return new DomPortalOutlet(element, this.appRef, this.injector);
  }
}
